import React from 'react'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Icon } from '../atoms/Icon'
import { Text } from '../atoms/text/Text'
import { Theme } from '@theme'
import { Scope } from '@utils'
import { useLanguage } from '@context'

interface ScopeBadgeProps {
  scope: Scope[]
  onChange?: (newScope: Scope) => void
}

export const ScopeBadge: React.FC<ScopeBadgeProps> = ({ scope, onChange }) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const isPrivate = scope.includes(Scope.PRIVATE)
  const styles = getStyle(theme, isPrivate)
  
  const handlePrivatePress = () => {
    if (onChange && !isPrivate) {
      onChange(Scope.PRIVATE)
    }
  }

  const handleProfessionalPress = () => {
    if (onChange && isPrivate) {
      onChange(Scope.PROFESSIONAL)
    }
  }

  return (
    <View style={styles.badgeContainer}>
      <View style={isPrivate? styles.activeBadge : styles.row}>
        <TouchableOpacity 
          style={styles.privateIconContainer}
          onPress={handlePrivatePress}
          disabled={!onChange}
        >
          <Icon 
            name="lock" 
            size={18} 
            color={isPrivate ? theme.colors.green : theme.colors.greyBlue} 
          />
        </TouchableOpacity>
        {isPrivate && <Text 
          type="bodyBold" 
          color={isPrivate? theme.colors.green : theme.colors.greyBlue} 
          style={styles.scopeText}
        >
          {t('common.private')}
        </Text>}
      </View>
      <View style={isPrivate? styles.row : styles.activeBadge}>
        <TouchableOpacity 
          style={styles.workIconContainer}
          onPress={handleProfessionalPress}
          disabled={!onChange}
        >
          <Icon 
            name="work" 
            size={18} 
            color={isPrivate ? theme.colors.greyBlue : theme.colors.primary} 
          />
        </TouchableOpacity>
        {!isPrivate && <Text 
          type="bodyBold" 
          color={isPrivate? theme.colors.greyBlue : theme.colors.primary} 
          style={styles.scopeTextPro}
        >
          {t('common.pro')}
        </Text>}
      </View>
    </View>
  )
}

const getStyle = (theme: Theme, isPrivate: boolean) => StyleSheet.create({
  badgeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.grey10,
    borderWidth: 1,
    borderColor: theme.colors.grey20,
    borderRadius: 25,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  activeBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    paddingRight: 10,
    borderRadius: 25
  },
  privateIconContainer: {
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isPrivate ? theme.colors.white :  undefined,
  },
  workIconContainer: {
    borderRadius: 15,
    width: 30,
    height: 30,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: isPrivate ? undefined :  theme.colors.white,
  },
  scopeText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  scopeTextPro: {
    fontSize: 16,
    fontWeight: 'bold'
  }
}) 